import { useMemo } from 'react';

interface PasswordCondition {
  satisfied: boolean;
  message: string;
}

export const usePasswordValidation = (
  password: string,
  confirmPassword: string,
): PasswordCondition[] => {
  return useMemo(() => {
    const criteria = [
      {
        checker: (password: string) => password.length >= 8,
        message: 'At least 8 characters.',
      },
      {
        checker: (password: string) => password.length > 0 && password === confirmPassword,
        message: 'Passwords match.',
      },
    ];

    return criteria.map((c) => ({
      satisfied: c.checker(password),
      message: c.message,
    }));
  }, [password, confirmPassword]);
};
